import { Component, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';

import { ICheckoutCartOffer, ICheckoutCartOfferDiscount } from '@/interfaces/Checkout';

const CheckoutModule = namespace('App/Checkout');

@Component
export default class PartnerMixin extends Vue {
  @CheckoutModule.Getter('selectedOffer')
  private readonly offer!: ICheckoutCartOffer;

  protected get partner() {
    const { ptn } = this.$route.query;
    let partner;

    if (ptn) {
      partner = ptn;
    } else if (this.offer.discounts) {
      const { discounts } = this.offer.discounts;

      const discountsWithPartner = discounts.filter(item => Boolean(item.partner_code));

      if (discountsWithPartner.length) {
        const discount = discountsWithPartner.reduce((a, b) => {
          if (a.applied_amount > b.applied_amount) {
            return a;
          } else if (b.applied_amount > a.applied_amount) {
            return b;
          } else {
            return (a.group_id > b.group_id) ? a : b;
          }
        });

        partner = discount.partner_code;
      }
    }

    return partner || '';
  }

  protected get isPartnerVisible () {
    return Boolean(this.partner);
  }

  protected get partnerImage() {
    try {
      return require(`@/assets/images/partners/${this.partner}.svg`);
    } catch (err) {
      return '';
    }
  }
}